// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as RelayRouter__Scroll from "./RelayRouter__Scroll.mjs";
import * as RelayRouter__Context from "./RelayRouter__Context.mjs";
import * as RelayRouter__Internal from "./RelayRouter__Internal.mjs";

function isModifiedEvent(e) {
  var match = e.metaKey;
  var match$1 = e.altKey;
  var match$2 = e.ctrlKey;
  var match$3 = e.shiftKey;
  if (match$2 || match$3 || match$1 || match) {
    return true;
  } else {
    return false;
  }
}

function RelayRouter__Link(props) {
  var onClick = props.onClick;
  var __preloadCode = props.preloadCode;
  var __preloadData = props.preloadData;
  var __preloadPriority = props.preloadPriority;
  var __mode = props.mode;
  var browserTarget = props.target;
  var to_ = props.to_;
  var mode = __mode !== undefined ? __mode : "push";
  var preloadPriority = __preloadPriority !== undefined ? __preloadPriority : "Default";
  var preloadData = __preloadData !== undefined ? __preloadData : "OnIntent";
  var preloadCode = __preloadCode !== undefined ? __preloadCode : "OnInView";
  var linkElement = React.useRef(null);
  var hasPreloaded = React.useRef(false);
  var router = RelayRouter__Context.useRouterContext();
  var history = router.history;
  var targetElementRef = RelayRouter__Scroll.TargetScrollElement.useTargetElement();
  var startTransition = RelayRouter__Internal.RouterTransitionContext.use();
  var changeRoute = React.useCallback((function (e) {
          startTransition(function () {
                router.postRouterEvent({
                      TAG: "OnBeforeNavigation",
                      currentLocation: router.get().location
                    });
                var match = e.isDefaultPrevented();
                var match$1 = e.button;
                var match$2 = isModifiedEvent(e);
                if (match) {
                  return ;
                }
                if (match$1 !== 0) {
                  return ;
                }
                if (browserTarget !== undefined && browserTarget !== "self") {
                  return ;
                }
                if (match$2) {
                  return ;
                } else {
                  e.preventDefault();
                  if (mode === "replace") {
                    history.replace(to_);
                  } else {
                    history.push(to_);
                  }
                  return ;
                }
              });
        }), [
        to_,
        history,
        router.postRouterEvent,
        startTransition
      ]);
  var doPreloadDataAndCode = React.useCallback((function (overridePriority) {
          router.preload(Core__Option.getOr(overridePriority, preloadPriority), to_);
        }), [
        to_,
        router.preload,
        preloadPriority
      ]);
  var doPreloadCode = React.useCallback((function (overridePriority) {
          router.preloadCode(Core__Option.getOr(overridePriority, preloadPriority), to_);
        }), [
        to_,
        router.preloadCode,
        preloadPriority
      ]);
  var onIntent = React.useCallback((function (overridePriority) {
          if (preloadData === "OnIntent") {
            return doPreloadDataAndCode(overridePriority);
          } else if (preloadCode === "OnIntent") {
            return doPreloadCode(overridePriority);
          } else {
            return ;
          }
        }), [
        preloadData,
        preloadCode,
        doPreloadCode,
        doPreloadDataAndCode
      ]);
  var onRender = React.useCallback((function (overridePriority) {
          if (preloadData === "OnRender") {
            return doPreloadDataAndCode(overridePriority);
          } else if (preloadCode === "OnRender") {
            return doPreloadCode(overridePriority);
          } else {
            return ;
          }
        }), [
        preloadData,
        preloadCode,
        doPreloadCode,
        doPreloadDataAndCode
      ]);
  React.useEffect((function () {
          onRender(undefined);
        }), [onRender]);
  if (import.meta.env.SSR) {
    onRender(undefined);
  }
  React.useEffect((function () {
          var match = linkElement.current;
          var linkElement$1;
          if (match === null || match === undefined) {
            return ;
          }
          if (preloadData === "OnInView") {
            linkElement$1 = match;
          } else {
            if (preloadCode !== "OnInView") {
              return ;
            }
            linkElement$1 = match;
          }
          var observer = new IntersectionObserver((function (entries) {
                  var isVisible = entries.some(function (entry) {
                        if (entry.isIntersecting) {
                          return entry.target === linkElement$1;
                        } else {
                          return false;
                        }
                      });
                  var match = hasPreloaded.current;
                  if (match) {
                    return ;
                  }
                  if (!isVisible) {
                    return ;
                  }
                  if (preloadData === "OnInView") {
                    doPreloadDataAndCode(undefined);
                    hasPreloaded.current = true;
                    return ;
                  }
                  if (preloadCode !== "OnInView") {
                    return ;
                  }
                  doPreloadCode(undefined);
                  hasPreloaded.current = true;
                }), {
                threshold: 1,
                root: targetElementRef !== undefined ? Caml_option.nullable_to_opt(targetElementRef.targetElementRef.current) : undefined
              });
          observer.observe(linkElement$1);
          return (function () {
                    observer.disconnect();
                  });
        }), [
        preloadCode,
        preloadData,
        doPreloadCode,
        doPreloadDataAndCode
      ]);
  return JsxRuntime.jsx("a", {
              children: props.children,
              ref: Caml_option.some(linkElement),
              className: props.className,
              id: props.id,
              style: props.style,
              tabIndex: props.tabIndex,
              title: props.title,
              href: to_,
              target: browserTarget !== undefined ? (
                  browserTarget === "blank" ? "_blank" : "_self"
                ) : "",
              onFocus: (function (param) {
                  onIntent(undefined);
                }),
              onClick: (function (e) {
                  changeRoute(e);
                  if (onClick !== undefined) {
                    return onClick();
                  }
                  
                }),
              onMouseDown: (function (param) {
                  doPreloadDataAndCode("High");
                }),
              onMouseEnter: (function (param) {
                  onIntent(undefined);
                }),
              onTouchStart: (function (param) {
                  doPreloadDataAndCode("High");
                })
            });
}

var make = RelayRouter__Link;

export {
  make ,
}
/* react Not a pure module */
